<script>
  import Image from "../Image.svelte";
  import Headlines from "./Headlines.svelte";
  import Text from "$lib/Text.svelte";
  import { fade, slideIn, slideOut } from "$lib/transitions.js";
  import { linkResolver } from "$lib/prismic";
  export let slides;
  export let active;

  let cursor;
  let x = 0;
  let y = 0;
  let left = false;
  let right = false;
  const mousemove = (e) => {
    hideCursor = e.target.tagName === "A";
    x = e.clientX;
    y = e.clientY;
    let width = window.innerWidth;
    let percent = (x / width) * 100;
    left = slides.length > 1 && percent < 10;
    right = slides.length > 1 && percent > 90;
  };

  const mod = (n, m) => {
    return ((n % m) + m) % m;
  };

  const click = () => {
    if (!left && !right) {
      active = -1;
      return;
    }
    active = mod(left ? active - 1 : active + 1, slides.length);
  };
  let hideCursor = false;
  let touches = [];
  let touchesMove = [];
</script>

<svelte:window
  on:mousemove={mousemove}
  on:touchstart={(e) => {
    hideCursor = true;
    touches = e.touches;
  }}
  on:touchmove={(e) => (touchesMove = e.touches)}
  on:touchend={(e) => {
    if (active === -1 || !touchesMove.length || !touches.length) {
      active = -1;
      return;
    }
    const deltaX = Math.abs(touchesMove[0].pageX - touches[0].pageX);
    const deltaY = Math.abs(touchesMove[0].pageY - touches[0].pageY);
    if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 40) {
      left = touchesMove[0].pageX < touches[0].pageX;
      right = !left;
      active = mod(left ? active - 1 : active + 1, slides.length);
    } else if (deltaX < 20 && deltaY < 20) {
      active = -1;
      return;
    }
    touches = e.touches;
    touchesMove = e.touches;
  }}
/>
{#if active > -1}
  <div
    class="block fixed top-16 inset-x-0 bottom-0 light cursor-none z-10 overflow-x-hidden overflow-y-auto"
    on:mouseup={click}
    transition:fade|global
  >
    {#each slides as slide, index}
      {#if index === active}
        <div
          class="absolute inset-0 flex flex-wrap"
          in:slideIn|global={{ left, duration: 250 }}
          out:slideOut|global={{ left }}
        >
          <div class="w-full md:w-1/2 flex order-3 md:order-1">
            <div class="block p-8 md:hidden">
              <Headlines
                headlines={{
                  headline: slide.headline[0],
                  subline: slide.subline[0],
                }}
              />
              <Text text={slide.text} class="mt-8" />
            </div>
          </div>
          <div class="w-full md:w-1/2 relative order-2">
            <Image
              image={slide.image}
              class="md:absolute md:inset-0 md:object-cover w-full block md:h-full"
            />
          </div>
        </div>

        <div
          class="hidden md:flex absolute inset-0 mt-16 items-center order-2"
          in:slideIn|global={{ left, duration: 500 }}
          out:slideOut|global={{ left }}
        >
          <div class="max-w-layout w-full mx-auto flex">
            <div class="w-full md:w-1/2 p-8 pr-16">
              <Headlines
                headlines={{
                  headline: slide.headline[0],
                  subline: slide.subline[0],
                }}
              />
              <Text text={slide.text} class="mt-8" />
              {#if slide.button_text}
                <a
                  class="btn mt-4"
                  href={slide.button_link.url ||
                    linkResolver(slide.button_link._meta)}
                  target={slide.button_link.target}>{slide.button_text}</a
                >
              {/if}
            </div>
          </div>
        </div>
      {/if}
    {/each}
    {#if !hideCursor}
      <div
        class="cursor fixed w-16 h-16 rounded-full border-3 border-darkgray transform origin-top-left top-0 left-0 z-50 cursor-none pointer-events-none {left
          ? 'left'
          : ''} {right ? 'right' : ''}"
        style="transform: translate(calc({x}px - 50%), calc({y}px - 50%)"
        bind:this={cursor}
        transition:fade|global
      />
    {/if}
  </div>
{/if}

<style lang="postcss">
  .cursor {
    &:before,
    &:after {
      content: "";
      @apply block h-3px w-12 absolute inset-0 m-auto bg-darkgray transition-all duration-300 origin-center;
    }
    &:before {
      transform: rotate(45deg);
    }
    &:after {
      transform: rotate(-45deg);
    }
    &.left,
    &.right {
      &:before,
      &:after {
        @apply w-6;
      }
    }
    &.left {
      &:before {
        transform: translate(-10%, -250%) rotate(-225deg);
      }
      &:after {
        transform: translate(-10%, 250%) rotate(225deg);
      }
    }
    &.right {
      &:before {
        transform: translate(10%, 250%) rotate(-45deg);
      }
      &:after {
        transform: translate(10%, -250%) rotate(45deg);
      }
    }
  }
</style>
